import React from 'react'
import Slider from 'lib/ui/Slider'
import {Controller, UseFormMethods} from 'react-hook-form'
import {DEFAULT_FONT_SIZE} from 'Event/Dashboard/components/NavButton'
import {Label} from 'lib/ui/typography'
import ColorPicker from 'lib/ui/ColorPicker'
import FontSelect from 'lib/FontSelect'
import CollapsibleSection from 'lib/ui/ConfigPanel/CollapsibleSection'
import {CAPS} from 'lib/ui/typography/FontStyleInput'
import {CountDownTimerSettings} from 'Event/Dashboard/components/CountDownTimer'

export default function TypographySection(props: {
  control: UseFormMethods['control']
  countDownTimer: CountDownTimerSettings
  namePrefix?: string
}) {
  const {control, countDownTimer, namePrefix = ''} = props

  return (
    <>
      <CollapsibleSection label={'Numbers Typography'}>
        <Label>Font</Label>
        <Controller
          control={control}
          name={`${namePrefix}numberStyles.font`}
          defaultValue={{
            family: countDownTimer.numberStyles.font?.family || 'inherit',
            variants: countDownTimer.numberStyles.font?.variants || [],
            styles: countDownTimer.numberStyles.font?.styles || [CAPS],
          }}
          render={({value, onChange}) => (
            <FontSelect value={value} onChange={onChange} />
          )}
        />
        <Controller
          name={`${namePrefix}numberStyles.fontSize`}
          defaultValue={
            countDownTimer.numberStyles.fontSize || DEFAULT_FONT_SIZE
          }
          control={control}
          render={({value, onChange}) => (
            <Slider
              min={1}
              max={100}
              onChange={onChange}
              valueLabelDisplay="off"
              value={value}
              label="Font Size"
            />
          )}
        />
        <Controller
          name={`${namePrefix}numberStyles.color`}
          control={control}
          defaultValue={countDownTimer.numberStyles.color}
          render={({value, onChange}) => (
            <ColorPicker label="Color" color={value} onPick={onChange} />
          )}
        />
      </CollapsibleSection>

      <CollapsibleSection label={'Labels Typography'}>
        <Label>Font</Label>
        <Controller
          control={control}
          name={`${namePrefix}labelStyles.font`}
          defaultValue={{
            family: countDownTimer.labelStyles.font?.family || 'inherit',
            variants: countDownTimer.labelStyles.font?.variants || [],
            styles: countDownTimer.labelStyles.font?.styles || [],
          }}
          render={({value, onChange}) => (
            <FontSelect value={value} onChange={onChange} />
          )}
        />
        <Controller
          name={`${namePrefix}labelStyles.fontSize`}
          defaultValue={
            countDownTimer.labelStyles.fontSize || DEFAULT_FONT_SIZE
          }
          control={control}
          render={({value, onChange}) => (
            <Slider
              min={1}
              max={100}
              onChange={onChange}
              valueLabelDisplay="off"
              value={value}
              label="Font Size"
            />
          )}
        />
        <Controller
          name={`${namePrefix}labelStyles.color`}
          control={control}
          defaultValue={countDownTimer.labelStyles.color}
          render={({value, onChange}) => (
            <ColorPicker label="Color" color={value} onPick={onChange} />
          )}
        />
      </CollapsibleSection>
    </>
  )
}
